<header class="header relative z-[9999]">
  <!-- ROW 1: Top bar - small, light bg -->
  <div class="iwan-topbar bg-iwan-topbar h-11 flex items-center text-sm">
    <div class="container flex items-center justify-between">
      <!-- Links: Publishing Services | Famous Authors | Blog | About | Contact -->
      <ul class="hidden lg:flex items-center gap-3 list-none m-0 p-0">
        <li><a routerLink="/publishing-services" class="text-iwan-text no-underline hover:text-iwan-primary font-sans whitespace-nowrap">{{ 'nav.publishingServices' | translate }}</a></li>
        <li class="text-iwan-divider select-none">|</li>
        <li><a routerLink="/famous-writers" class="text-iwan-text no-underline hover:text-iwan-primary font-sans whitespace-nowrap">{{ 'nav.famousWriters' | translate }}</a></li>
        <li class="text-iwan-divider select-none">|</li>
        <li><a routerLink="/blog" class="text-iwan-text no-underline hover:text-iwan-primary font-sans whitespace-nowrap">{{ 'nav.blog' | translate }}</a></li>
        <li class="text-iwan-divider select-none">|</li>
        <li><a routerLink="/about" class="text-iwan-text no-underline hover:text-iwan-primary font-sans whitespace-nowrap">{{ 'nav.about' | translate }}</a></li>
        <li class="text-iwan-divider select-none">|</li>
        <li><a routerLink="/contact" class="text-iwan-text no-underline hover:text-iwan-primary font-sans whitespace-nowrap">{{ 'nav.contact' | translate }}</a></li>
      </ul>
      <!-- Language switcher -->
      <button type="button" (click)="onToggleLang()" class="text-iwan-text hover:text-iwan-primary font-sans text-sm bg-transparent border-0 cursor-pointer">
        {{ language.currentLang === 'ar' ? 'English' : 'العربية' }}
      </button>
    </div>
  </div>

  <!-- ROW 2: Main header - white, with shadow -->
  <nav class="iwan-header-main bg-white shadow-iwan flex items-center h-[80px]">
    <div class="container flex items-center gap-5 h-full">
      <!-- Logo -->
      <a routerLink="/" class="flex-shrink-0 flex items-center">
        <img src="assets/images/logo.png" alt="Iwan" class="h-16 w-auto" />
      </a>
      <!-- Browse Books | Publish Your Book -->
      <ul class="hidden lg:flex items-center gap-0 list-none m-0 p-0 flex-shrink-0">
        <li><a routerLink="/books" routerLinkActive="text-iwan-primary" class="font-bold text-iwan-text px-3 py-2 no-underline hover:text-iwan-primary text-base whitespace-nowrap">{{ 'nav.books' | translate }}</a></li>
        <li><span class="w-px h-4 bg-iwan-divider mx-1" aria-hidden="true"></span></li>
        <li><a [routerLink]="publishLink" [queryParams]="publishLinkQueryParams" routerLinkActive="text-iwan-primary" [routerLinkActiveOptions]="{ exact: false }" class="font-bold text-iwan-text px-3 py-2 no-underline hover:text-iwan-primary text-base whitespace-nowrap">{{ 'nav.publish' | translate }}</a></li>
      </ul>
      <!-- Search bar -->
      <form class="hidden lg:flex items-center bg-white border border-iwan-border rounded-iwan-lg h-11 flex-1 min-w-0 max-w-md" (submit)="$event.preventDefault(); onSearch(searchInput.value)">
        <button type="submit" class="px-3 border-0 bg-transparent text-iwan-primary flex-shrink-0 cursor-pointer" aria-label="Search">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        </button>
        <input #searchInput type="text" class="flex-1 border-0 bg-transparent px-2 outline-none text-iwan-text font-sans min-w-0 text-sm placeholder:text-iwan-text-muted" [placeholder]="'common.searchPlaceholder' | translate" />
      </form>
      <!-- Auth buttons -->
      <div class="hidden lg:flex items-center gap-3 flex-shrink-0 ms-auto">
        @if (auth.isAuthenticated) {
          @if (!auth.hasAnySubscription) {
            <a routerLink="/plans" class="btn btn-accent btn-sm whitespace-nowrap flex items-center gap-1.5">
              <span class="text-[10px]" aria-hidden="true">&#9660;</span>
              {{ 'nav.startExploring' | translate }}
            </a>
          }
          <a routerLink="/profile" class="text-iwan-text btn-outline btn-sm btn no-underline text-base font-sans whitespace-nowrap flex items-center gap-2">
            @if ((auth.currentUser$ | async)?.avatar; as avatar) {
              <img [src]="avatar" alt="" class="w-6 h-6 rounded-full object-cover" />
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-iwan-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" /></svg>
            }
            {{ 'nav.profile' | translate }}</a>
        } @else {
          <a routerLink="/login" class="text-iwan-text no-underline text-base hover:text-iwan-primary font-sans whitespace-nowrap">{{ 'nav.login' | translate }}</a>
          <a routerLink="/register" class="btn btn-primary btn-sm whitespace-nowrap flex items-center gap-1.5">
            <span class="text-white text-[10px]" aria-hidden="true">&#9660;</span>
            {{ 'nav.subscribeNow' | translate }}
          </a>
        }
      </div>
      <!-- Hamburger button (mobile only) -->
      <button
        type="button"
        class="lg:hidden ms-auto flex items-center justify-center w-10 h-10 text-iwan-text bg-transparent border-0 cursor-pointer"
        (click)="toggleMobileMenu()"
        aria-label="Toggle menu">
        @if (mobileMenuOpen) {
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/></svg>
        }
      </button>
    </div>
  </nav>

  <!-- Mobile side menu -->
  @if (mobileMenuOpen) {
    <div class="mobile-menu-backdrop lg:hidden" (click)="mobileMenuOpen = false"></div>
  }
  <aside class="mobile-menu lg:hidden" [class.mobile-menu--open]="mobileMenuOpen">
    <div class="mobile-menu__content">
      <!-- Search -->
      <form class="flex items-center bg-white border border-iwan-border rounded-iwan-lg h-11 w-full" (submit)="$event.preventDefault(); onSearch(mobileSearchInput.value); mobileMenuOpen = false">
        <button type="submit" class="px-3 border-0 bg-transparent text-iwan-primary flex-shrink-0 cursor-pointer" aria-label="Search">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        </button>
        <input #mobileSearchInput type="text" class="flex-1 border-0 bg-transparent px-2 outline-none text-iwan-text font-sans min-w-0 text-sm placeholder:text-iwan-text-muted" [placeholder]="'common.searchPlaceholder' | translate" />
      </form>

      <!-- Main nav links -->
      <nav class="mobile-menu__nav">
        <a routerLink="/books" routerLinkActive="text-iwan-primary" class="mobile-menu__link">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"/></svg>
          {{ 'nav.books' | translate }}
        </a>
        <a [routerLink]="publishLink" [queryParams]="publishLinkQueryParams" routerLinkActive="text-iwan-primary" [routerLinkActiveOptions]="{ exact: false }" class="mobile-menu__link">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125"/></svg>
          {{ 'nav.publish' | translate }}
        </a>
      </nav>

      <!-- Divider -->
      <div class="w-full h-px bg-iwan-border"></div>

      <!-- Secondary links (from top bar) -->
      <nav class="mobile-menu__nav">
        <a routerLink="/publishing-services" class="mobile-menu__link mobile-menu__link--secondary">{{ 'nav.publishingServices' | translate }}</a>
        <a routerLink="/famous-writers" class="mobile-menu__link mobile-menu__link--secondary">{{ 'nav.famousWriters' | translate }}</a>
        <a routerLink="/blog" class="mobile-menu__link mobile-menu__link--secondary">{{ 'nav.blog' | translate }}</a>
        <a routerLink="/about" class="mobile-menu__link mobile-menu__link--secondary">{{ 'nav.about' | translate }}</a>
        <a routerLink="/contact" class="mobile-menu__link mobile-menu__link--secondary">{{ 'nav.contact' | translate }}</a>
      </nav>

      <!-- Divider -->
      <div class="w-full h-px bg-iwan-border"></div>

      <!-- Auth section -->
      <div class="mobile-menu__auth">
        @if (auth.isAuthenticated) {
          @if (!auth.hasAnySubscription) {
            <a routerLink="/plans" class="btn btn-accent btn-block btn-sm flex items-center justify-center gap-1.5">
              <span class="text-[10px]" aria-hidden="true">&#9660;</span>
              {{ 'nav.startExploring' | translate }}
            </a>
          }
          <a routerLink="/profile" class="btn btn-outline btn-block btn-sm flex items-center justify-center gap-2">
            @if ((auth.currentUser$ | async)?.avatar; as avatar) {
              <img [src]="avatar" alt="" class="w-6 h-6 rounded-full object-cover" />
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-iwan-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" /></svg>
            }
            {{ 'nav.profile' | translate }}
          </a>
        } @else {
          <a routerLink="/login" class="btn btn-outline btn-block btn-sm">{{ 'nav.login' | translate }}</a>
          <a routerLink="/register" class="btn btn-primary btn-block btn-sm flex items-center justify-center gap-1.5">
            <span class="text-white text-[10px]" aria-hidden="true">&#9660;</span>
            {{ 'nav.subscribeNow' | translate }}
          </a>
        }
      </div>
    </div>
  </aside>

  <!-- ROW 3: Announcement bar (#810029) -->
  @if (!announcementDismissed) {
    <div class="flex items-center justify-center gap-1 flex-wrap text-white text-sm py-2 ps-4 pe-12 relative" style="background-color: #810029;">
      <span>{{ 'header.announcementBefore' | translate }}</span>
      <a routerLink="/download-app" class="font-bold underline hover:no-underline text-white">{{ 'header.announcementLink' | translate }}</a>
      <span>{{ 'header.announcementAfter' | translate }}</span>
      <button type="button" class="absolute end-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-white hover:opacity-80 bg-transparent border-0 cursor-pointer text-lg leading-none" (click)="dismissAnnouncement()" aria-label="Close">×</button>
    </div>
  }
</header>
